import React, { useState } from 'react';
import { airtableService } from '../services/airtable';

const CheckIn = ({ currentUser }) => {
  const [visitor, setVisitor] = useState({
    name: '',
    reason: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!visitor.name || !visitor.reason) {
      alert('Please fill in your name and reason for visit');
      return;
    }

    setIsSubmitting(true);
    
    const result = await airtableService.checkInVisitor({
      ...visitor,
      user: currentUser
    });

    setIsSubmitting(false);

    if (result) {
      setShowSuccess(true);
      setVisitor({
        name: visitor.name,
        reason: visitor.reason
      });
      
      // Hide success message after 5 seconds
      setTimeout(() => {
        setShowSuccess(false);
        setVisitor({
          name: '',
          reason: ''
        });
      }, 5000);
    } else {
      alert('Error checking in. Please try again.');
    }
  };

  const resetForm = () => {
    setVisitor({
      name: '',
      reason: ''
    });
    setShowSuccess(false);
  };

  if (showSuccess) {
    return (
      <div className="max-w-2xl mx-auto p-8">
        <div className="bg-green-50 border-2 border-green-200 rounded-xl p-8 text-center">
          <div className="text-6xl mb-4">✅</div>
          <h2 className="text-3xl font-bold text-green-800 mb-4">Welcome!</h2>
          <p className="text-xl text-green-700 mb-6">You have been successfully checked in.</p>
          
          <div className="bg-white rounded-lg p-6 mb-6">
            <h3 className="text-lg font-semibold mb-4">Check-In Successful!</h3>
            <p className="text-sm text-gray-600">
              You have been successfully registered for your visit.
            </p>
          </div>

          <div className="text-left bg-gray-50 rounded-lg p-4 mb-6">
            <h4 className="font-semibold mb-2">Visit Details:</h4>
            <p><strong>Name:</strong> {visitor.name}</p>
            <p><strong>Reason:</strong> {visitor.reason}</p>
            <p><strong>Time:</strong> {new Date().toLocaleString('en-US', { 
              timeZone: 'America/New_York',
              year: 'numeric',
              month: '2-digit', 
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit'
            })}</p>
          </div>

          <button
            onClick={resetForm}
            className="px-8 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 font-medium text-lg"
          >
            Check In Another Visitor
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto p-8">
      <div className="bg-white rounded-xl shadow-lg p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Visitor Check-In</h1>
          <p className="text-gray-600">Please provide your information to sign in</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-lg font-medium text-gray-700 mb-3">
              Full Name *
            </label>
            <input
              type="text"
              value={visitor.name}
              onChange={(e) => setVisitor({...visitor, name: e.target.value})}
              className="w-full px-4 py-4 text-lg border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter your full name"
              required
            />
          </div>

          <div>
            <label className="block text-lg font-medium text-gray-700 mb-3">
              Reason for Visit *
            </label>
            <textarea
              value={visitor.reason}
              onChange={(e) => setVisitor({...visitor, reason: e.target.value})}
              rows={3}
              className="w-full px-4 py-4 text-lg border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Meeting, dropping off items, etc."
              required
            />
          </div>

          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <h3 className="font-semibold text-yellow-800 mb-2">Important Notice:</h3>
            <ul className="text-sm text-yellow-700 space-y-1">
              <li>• All visitors must check out before leaving</li>
              <li>• Please proceed to the main office after check-in</li>
              <li>• Follow all school security protocols</li>
            </ul>
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className={`w-full py-4 text-xl font-semibold rounded-lg transition-colors ${
              isSubmitting
                ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                : 'bg-blue-500 text-white hover:bg-blue-600'
            }`}
          >
            {isSubmitting ? 'Checking In...' : 'Check In'}
          </button>
        </form>

        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500">
            Need help? Please contact the front desk.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CheckIn;
